import { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "antd";
import Title from "../../../components/Title";
import { BranchesOutlined } from "@ant-design/icons";
import DashboardPages from "../../../Dashboard/DashboardPages";
import Tables from "../../../components/Tables";
import {
  TYPE_CHECK_DASHBOARD,
  TYPE_GET_DATE,
  tabelMovitelDailyRevenue,
} from "../../../../helper/const";
import DailyRevenueChartMagicWheel from "../../../components/DailyRevenueChartMagicWheel";
import _ from "lodash";
import {
  formatDataDailyRevenueChartMagicWheel,
  formatDataDailyRevenueChartMovitel,
  formatDataNumberToen,
  formatDataQuantityMovitelOverview,
  formatDataQuantityMytelMagicWeelOverview,
  formatDataStatisticTableMagicWheel,
  formatDataStatisticTableMovitel,
  getDateChangeTime,
} from "../../../../helper/helper";
import { selectorDataMovitel } from "../../../../redux/selector";
import FilterTime from "../../../components/FilterTime";
import RevenueOfChannelChart from "../../../components/RevenueOfChannelChart";
import styled from "styled-components";

export default function Overview({ handleGetData, tabActive }) {
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneMonthAgo),
  );

  const { revenue = {} } = useSelector(selectorDataMovitel);
  const {
    dataList = [],
    dataOverview = [],
    dataDetail = [],
  } = revenue.result || {};
  let dataDailyRevenueChart = [];

  useEffect(() => {
    if (tabActive !== "1") return;
    // dispatch(getDataMagicWheel(apiRevenueMagicWheel(startDate, endDate)));
    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  let quantityRevenue = {
    data: [],
    xField: "time",
    yField: ["totalRevenue", "quantity"],

    annotations: {
      quantity: [],
    },
  };

  let columnsMagicRevenue = { dataKey: [], defineData: [] };
  let revenueOfChannel = {
    data: [],
    xField: "type",
    yField: ["revenue"],
  };

  useMemo(() => {
    quantityRevenue = formatDataQuantityMovitelOverview(
      dataList,
      TYPE_CHECK_DASHBOARD.overview,
    );

    revenueOfChannel = formatDataQuantityMovitelOverview(
      dataList,
      TYPE_CHECK_DASHBOARD.revenue,
    );

    columnsMagicRevenue = formatDataStatisticTableMovitel(dataOverview);

    console.log('dataDetail: ', dataDetail);

    dataDailyRevenueChart = formatDataDailyRevenueChartMovitel(dataDetail, 'MOVITEL');


    //Daily Revenue Table
    const formatDataApi = dataDetail.map((item = {}) => {
      const {
        chargeTime = 0,
        packs = [],
        value = 0,
        total_renew_revenue = 0,
        total_reg = 0,
        total_renew = 0,
      } = item;
      const defineDataDailyRevenueTable = {
        LETRA_MAGICA_DAY: {
          revenue: 0,
          total: 0
        },
        LETRA_MAGICA_WEEK: {
          revenue: 0,
          total: 0
        },
        LETRA_MAGICA_MON: {
          revenue: 0,
          total: 0
        },
        LETRA_MAGICA_MR_DAY: {
          revenue: 0,
          total: 0
        },
        LETRA_MAGICA_MR_MON: {
          revenue: 0,
          total: 0
        },
        LETRA_MAGICA_MR_WEEK: {
          revenue: 0,
          total: 0
        },
        LETRA_MAGICA_MINUS2: {
          revenue: 0,
          total: 0
        },
        LETRA_MAGICA_MINUS3: {
          revenue: 0,
          total: 0
        },
        LETRA_MAGICA_MINUS4: {
          revenue: 0,
          total: 0
        },
        LETRA_MAGICA_MINUS15: {
          revenue: 0,
          total: 0
        },
      };

      let RegisterRevenue = 0;
      let TotalRegister = 0;
      let TotalRegisterWithFee = 0;
      let TotalRenew = 0;
      let TotalCancel = 0;

      packs.forEach((packItem = {}) => {
        const idPack = packItem.id;


        // console.log("idPack::: ", defineDataDailyRevenueTable[idPack], "packItem.amount::: ", packItem.amount);
        defineDataDailyRevenueTable[idPack] = {
          revenue: (defineDataDailyRevenueTable[idPack]?.revenue || 0) + (packItem.total_reg_revenue || 0),
          // total = total_reg_with_fee + total_renew
          total: (defineDataDailyRevenueTable[idPack]?.total || 0) + (packItem.total_reg || 0),
        };

        // if (
        //   idPack === "LETRA_MAGICA_DAY" ||
        //   idPack === "LETRA_MAGICA_WEEK" ||
        //   idPack === "LETRA_MAGICA_MON" ||
        //   idPack === "LETRA_MAGICA_MR_DAY" ||
        //   idPack === "LETRA_MAGICA_MR_MON" ||
        //   idPack === "LETRA_MAGICA_MR_WEEK"
        // ) {
        RegisterRevenue += packItem.total_reg_revenue || 0;
        // }
        TotalRegister += packItem.total_reg || 0;
        TotalRegisterWithFee += packItem.total_reg_with_fee || 0;
        TotalRenew += packItem.total_renew || 0;
        TotalCancel += packItem.total_cancel || 0;
      });

      const RetailRevenue =
        +defineDataDailyRevenueTable.LETRA_MAGICA_MINUS2.revenue +
        +defineDataDailyRevenueTable.LETRA_MAGICA_MINUS3.revenue +
        +defineDataDailyRevenueTable.LETRA_MAGICA_MINUS4.revenue +
        +defineDataDailyRevenueTable.LETRA_MAGICA_MINUS15.revenue;

      return {
        Chargetime: chargeTime,
        Day: defineDataDailyRevenueTable.LETRA_MAGICA_DAY,
        Week: defineDataDailyRevenueTable.LETRA_MAGICA_WEEK,
        Month: defineDataDailyRevenueTable.LETRA_MAGICA_MON,
        MrDay: defineDataDailyRevenueTable.LETRA_MAGICA_MR_DAY,
        MrMon: defineDataDailyRevenueTable.LETRA_MAGICA_MR_MON,
        MrWeek: defineDataDailyRevenueTable.LETRA_MAGICA_MR_WEEK,
        Minus2: defineDataDailyRevenueTable.LETRA_MAGICA_MINUS2,
        Minus3: defineDataDailyRevenueTable.LETRA_MAGICA_MINUS3,
        Minus4: defineDataDailyRevenueTable.LETRA_MAGICA_MINUS4,
        Minus15: defineDataDailyRevenueTable.LETRA_MAGICA_MINUS15,
        RegisterRevenue,
        RenewRevenue: total_renew_revenue,
        TotalRegister: TotalRegister,
        TotalRegisterWithFee: TotalRegisterWithFee,
        TotalRenew: TotalRenew,
        TotalCancel: TotalCancel,
        RetailRevenue,
        TotalRevenue: value,
      };
    });

    let total = {
      MrDay: {
        total: 0,
        revenue: 0,
      },
      MrMon: {
        total: 0,
        revenue: 0,
      },
      MrWeek: {
        total: 0,
        revenue: 0,
      },
      Minus2: {
        total: 0,
        revenue: 0,
      },
      Minus3: {
        total: 0,
        revenue: 0,
      },
      Minus4: {
        total: 0,
        revenue: 0,
      },
      Minus15: {
        total: 0,
        revenue: 0,
      },
      Chargetime: "Total",
      Day: {
        total: 0,
        revenue: 0,
      },
      TotalRevenue: 0,
      RetailRevenue: 0,
      RenewRevenue: 0,
      TotalRegister: 0,
      TotalRegisterWithFee: 0,
      TotalRenew: 0,
      TotalCancel: 0,
      RegisterRevenue: 0,
      Month: {
        total: 0,
        revenue: 0,
      },
      Week: {
        total: 0,
        revenue: 0,
      },
    };

    formatDataApi.forEach((item) => {
      total.Day.total += item.Day.total || 0;
      total.Day.revenue += item.Day.revenue || 0;
      total.Week.total += item.Week.total || 0;
      total.Week.revenue += item.Week.revenue || 0;
      total.Month.total += item.Month.total || 0;
      total.Month.revenue += item.Month.revenue || 0;
      total.MrDay.total += item.MrDay.total || 0;
      total.MrDay.revenue += item.MrDay.revenue || 0;
      total.MrMon.total += item.MrMon.total || 0;
      total.MrMon.revenue += item.MrMon.revenue || 0;
      total.MrWeek.total += item.MrWeek.total || 0;
      total.MrWeek.revenue += item.MrWeek.revenue || 0;
      total.Minus2.total += item.Minus2.total || 0;
      total.Minus2.revenue += item.Minus2.revenue || 0;
      total.Minus3.total += item.Minus3.total || 0;
      total.Minus3.revenue += item.Minus3.revenue || 0;
      total.Minus4.total += item.Minus4.total || 0;
      total.Minus4.revenue += item.Minus4.revenue || 0;
      total.Minus15.total += item.Minus15.total || 0;
      total.Minus15.revenue += item.Minus15.revenue || 0;
      total.TotalRevenue += item.TotalRevenue || 0;
      total.RenewRevenue += item.RenewRevenue || 0;
      total.TotalRegister += item.TotalRegister || 0;
      total.TotalRegisterWithFee += item.TotalRegisterWithFee || 0;
      total.TotalRenew += item.TotalRenew || 0;
      total.TotalCancel += item.TotalCancel || 0;
      total.RegisterRevenue += item.RegisterRevenue || 0;
      total.RetailRevenue += item.RetailRevenue || 0;
    });

    for (const key in total) {
      if (typeof total[key] === "number") {
        total[key] = parseFloat(total[key].toFixed(3));
      }
    }
    let data = [total, ...formatDataApi].reverse();
    tabelMovitelDailyRevenue.defineData = data.map((item) => {
      for (let x in item) {
        if (typeof item[x] === "number") {
          item[x] = formatDataNumberToen(item[x]);
        }
      }
      return item;
    });
    console.log('tabelMovitelDailyRevenue: ', tabelMovitelDailyRevenue);
  }, [revenue.result]);

  return (
    <Container className="reponsitite-container">
      <div className="container-dashboard">
        <div className="d-flex justify-content-end mb-2">
          <FilterTime
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
          />
        </div>
        <Row className="panel panel-sortable">
          <Title titleName="Overview">
            <BranchesOutlined />
          </Title>
          <Col span={24}>
            <Row>
              <Col
                xxl={12}
                xl={12}
                lg={12}
                md={24}
                sm={24}
                xs={24}
                className="container-item"
              >
                <h4 className="pt-3 pe-3">
                  Overview Quantity - Revenue chart:
                </h4>
                <div className="item-chart">
                  <DashboardPages dataDashboard={quantityRevenue} />
                </div>
              </Col>
              <Col
                xxl={12}
                xl={12}
                lg={12}
                md={24}
                sm={24}
                xs={24}
                className="container-item"
              >
                <h4 className="pt-3 pe-3">Revenue of channel chart:</h4>

                <div className="item-chart">
                  <RevenueOfChannelChart dataChart={revenueOfChannel} />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div id="table-bitel">
        <Tables
          columns={columnsMagicRevenue}
          title="Overview statistic table"
          isHiddenPagination={false}
        />
      </div>
      <div className="container-dashboard pt-0">
        <Row className="panel panel-sortable">
          <Title titleName="Daily Revenue Chart">
            <BranchesOutlined />
          </Title>
          <div className="container-revenueOfChannelChart">
            <div className="revenueOfChannelChart">
              <DailyRevenueChartMagicWheel
                dataRevenueChart={dataDailyRevenueChart}
              />
            </div>
          </div>
        </Row>
      </div>
      <Tables columns={tabelMovitelDailyRevenue} title="Daily Revenue Table" />
      {/* <ProjectInformation id={idProject.mytel} /> */}
    </Container>
  );
}

const Container = styled.div`
  .container-revenueOfChannelChart {
    width: 100%;
    overflow-x: auto;
  }

  .revenueOfChannelChart {
    min-width: 800px;
    overflow-x: scroll;
  }
`;
